import { useApiDefaults } from './useApiDefaults';
import { useQuery } from '@tanstack/react-query';
import axios from 'config/axios';
import { ReactQueryKeys } from 'config/constant';
import { useSelector } from 'react-redux';
import { refetchOnWindowFocus } from 'config/reactQuery';

export function useGetCouponList(enabled = true, sendFilteredData = false) {
  const apiDefaults = useApiDefaults();
  const {categoryIds} = useSelector(({coupon}) => coupon)
  const { searchText } = useSelector(({ search }) => search);
  
  const updatedCategoryIds = categoryIds?.includes("0") ? ["0"] : categoryIds.filter(id => id !== "0");
  const body = {
    ...apiDefaults,
    product_category_ids: updatedCategoryIds || [],
    product_category_id: updatedCategoryIds?.[0]
  };

  const getCouponList = async () => {
    if (!updatedCategoryIds || updatedCategoryIds.length === 0) {
      return [];
    }
    
    const response = await axios.post("/AogGetDetailsForCoupons", body);
    return response?.data?.data || [];
  };

  const {
    data: couponList = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: [ReactQueryKeys.COUPON_LIST, updatedCategoryIds, apiDefaults],
    queryFn: getCouponList,
    enabled,
    refetchOnWindowFocus,
  });

  if (sendFilteredData) {
    const updatedCouponList =
      couponList && couponList.length
        ? couponList.filter((coupon) => {
          let result = false;
          searchText?.split(" ")?.forEach((text) => {
            const lowerText = text?.toLowerCase();
            const lowerDetails = coupon?.details?.toLowerCase();
            const lowerTitle = coupon?.title?.toLowerCase();
            result = lowerDetails.includes(lowerText) || lowerTitle.includes(lowerText);
          });
          return result;
        })
        : [];

    return {
      couponList: updatedCouponList,
      isLoading,
      error,
    }
  }


  return {
    couponList,
    isLoading,
    error,
  };
}